import { makeStyles } from "@material-ui/core";
import React, { useCallback } from "react";
import Select from "react-select";
import { ValueType } from "react-select/src/types";

import { UserLevel } from "../../../../enums/userLevel";

import { useAccountTypeOptions } from "./useAccountTypeOptions";

interface Props {
    value: UserLevel | undefined;
    setValue: (value: UserLevel | undefined) => void;
    isDealerSelected: boolean;
    isOrgSelected: boolean;
    isSiteSelected: boolean;
}

export function AccountTypeSelect({
    value,
    setValue,
    isDealerSelected,
    isOrgSelected,
    isSiteSelected,
}: Props) {
    const classes = useStyles();

    const availableOptions = useAccountTypeOptions({ isDealerSelected, isOrgSelected, isSiteSelected });

    const handleChange = useCallback((selectedValue: ValueType<{ value: UserLevel; label: UserLevel; }>) => {
        const typedSelectedValue = selectedValue as { value: UserLevel; label: UserLevel; } | null;
        if (!typedSelectedValue) {
            setValue(undefined)
            return;
        };
        setValue(typedSelectedValue.value);
    }, [setValue]);

    return (
        <div className={classes.container}>
            <label htmlFor="account-type-select">Account Type:</label>
            <Select
                inputId="account-type-select"
                options={availableOptions}
                value={value ? { value: value, label: value } : null}
                noOptionsMessage={() => "Select..."}
                onChange={handleChange}
                isClearable={true}
                isSearchable={false}
                styles={{
                    container: base => ({ ...base, width: 280 }),
                }}
            />
        </div>
    );
}

const useStyles = makeStyles({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        marginTop: "20px",
        marginBottom: "10px",
        maxWidth: "400px",
    },
});